import { Select as MantineSelect, type SelectProps } from "@mantine/core";
import { forwardRef, useMemo } from "react";
import {
  normalizeSelectData,
  normalizeSelectValue,
} from "src/utils/mantineComboboxData";

export type { SelectProps };

const Select = forwardRef<HTMLInputElement, SelectProps>(
  ({ data, value, ...props }, ref) => {
    const normalizedData = useMemo(
      () => (data ? normalizeSelectData(data) : data),
      [data],
    );

    const normalizedValue =
      value !== undefined ? normalizeSelectValue(value) : value;

    return (
      <MantineSelect
        {...props}
        ref={ref}
        data={normalizedData}
        value={normalizedValue}
      />
    );
  },
);

Select.displayName = "Select";

export default Select;
